import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input
}                                   from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-ng-select-control',
  styles: [ require('./ng-select-control.component.scss') ],
  template: require('./ng-select-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class NgSelectControlComponent extends TextControlComponent implements AfterViewInit {
  @Input() optionLabel: string;
  @Input() options    : Array<any>;
  @Input() optionValue: string;

  _multiple : boolean;

  @Input() set multiple ( _multiple : string | boolean ) {
    this._multiple = _multiple === '' || !!_multiple;
  }

  selectedValues: Array<any>;

  constructor (
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit () : void {
    this.selectedValues = [ ...this._model ];

    this.changeDetectorRef.detectChanges();
  }

  handleModelChange ( event : any ) {
    this._model = [ ...this.selectedValues ];

    this.modelChange.emit(this._model);
  }
}
